import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { ShippingLine } from '../../../models/shippingLines/shippingLine';
import { AlertService } from '../../../services/alert.service';
import { ShippingLineService } from '../../../services/shipping-line.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
	selector: 'app-shipping-line-form',
	templateUrl: './shipping-line-form.component.html',
	styleUrls: ['./shipping-line-form.component.css']
})
export class ShippingLineFormComponent implements OnInit {
	form: FormGroup;
	shippingLine: ShippingLine = new ShippingLine();
	loading: boolean = false;

	constructor(
		private _shippingLineService: ShippingLineService,
		private _activatedRoute: ActivatedRoute,
		private _router: Router,
		private _alertService: AlertService
	) { }

	ngOnInit() {
		this._activatedRoute.params.subscribe(
			x => {
				this.init();
			}
		);
	}

	private init(){
		let id = this._activatedRoute.snapshot.params['id'];
		this.shippingLine = new ShippingLine();
		this.shippingLine.id = id;

		this.form = this.createForm(this.shippingLine);

		if (id == 0) {
			this.shippingLine.id = 0;
		}
		else {
			this._shippingLineService.getShippingLine(id).subscribe(
				result => {
					if (result == undefined) {
						this.shippingLine.id = 0;
					}
					else {
						this.shippingLine = result;
						this.form = this.createForm(this.shippingLine)
					}
				}
			);
		}
	}

	private createForm(shippingLine: ShippingLine): FormGroup {
		return new FormGroup({
			name: new FormControl(shippingLine.name, [
				Validators.required,
				Validators.maxLength(50)
			])
		});
	}

	onFormSubmit(formValue) {
		//update client item
		this.shippingLine.name = formValue.name;
		this.loading = true;
		if (this.shippingLine.id == undefined || this.shippingLine.id == 0) {
			this.createShippingLine();
		}
		else {
			this.updateShippingLine();
		}
	}

	private createShippingLine() {
		this._shippingLineService.addShippingLine(this.shippingLine).subscribe(
			result => {
				if (result != undefined && result['object'] != undefined) {
					this.shippingLine = result.object;
					this._alertService.showSuccess('Shipping line registered.');
				}
				else {
					this._alertService.displayErrorResult(result.errorCollection);
				}
				this.loading = false;
			}
		);
	}

	private updateShippingLine() {
		this._shippingLineService.updateShippingLine(this.shippingLine).subscribe(
			result => {
				if (result != undefined && result['object'] != undefined) {
					this.shippingLine = result.object;
					this._alertService.showSuccess('Shipping line data updated.');
				}
				else {
					this._alertService.displayErrorResult(result.errorCollection);
				}
				this.loading = false;
			}
		);
	}

	isControlInvalid(controlName: string) {
		let control = this.form.controls[controlName];
		return control.invalid && (control.dirty || control.touched);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shippingLines/shipping-line-form/shipping-line-form.component.ts